import Notification from './Notification'
import TextImage from './TextImage'
import ImageText from './ImageText'
import Symptoms from './Symptoms'
import Testimonials from './Testimonials'
import Cards from './Cards'

const Content = ({
  notification,
  sectionImageText,
  sectionReason,
  sectionTestimonials,
  sectionTextImage,
  ctaButton,
  ctaButtonSecondary,
  symptoms,
}) => {
  return (
    <>
      <Notification content={notification} enable={false} />
      <TextImage
        {...sectionTextImage}
        ctaButton={ctaButton}
        ctaButtonSecondary={ctaButtonSecondary}
      />
      <Cards {...sectionReason} />
      <Symptoms content={symptoms} />
      <Testimonials
        {...sectionTestimonials}
        ctaButton={ctaButton}
        ctaButtonSecondary={ctaButtonSecondary}
      />
      <ImageText {...sectionImageText} />
    </>
  )
}

export default Content
